var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"title-group-page"},[_c('layout',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('title-group')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }